import axios from "axios";
import { API_URL } from "../config/constants";

// const API_URL = "http://localhost:5000/api/auth/";

const END_POINT = `${API_URL}auth/`

// export const ImagePath="D:/IboostPatientHealthcare/iboosthealthcare0703/server/uploaded_images/"
// export const ImagePath="http://localhost:5000/uploaded_images/"
export const FolderPath = "http://localhost:5000"
export const ImagePath = `${FolderPath}/`

export const addingRegisterDetails = (formData) => {
  return axios
      .post(`${END_POINT}add-register`, formData)
      .then((response) => {
          return response;
      }).catch(e => {
          return e?.response;
      });
};

export const loginDetails = (email,password) => {
  return axios
      .post(`${END_POINT}login`, {email,password})
      .then((response) => {
          return response;
      }).catch(e => {
          return e?.response;
      });
};


// export const forgotpassword = (email: string) => {
//   return axios
//     .post(API_URL + "forgot-password", {
//       email

//     })
//     .then((response) => {


//       return response?.data;
//     });
// };

// export const resetpassword = (confirmpassword: string, url: string) => {
//   return axios
//     .post(API_URL + "emailrecover-password", {
//       confirmpassword,
//       url

//     })
//     .then((response) => {


//       return response?.data;
//     });
// };

export const logout = () => {
  localStorage.removeItem("user");
};



